import React from "react";

import Box from "@material-ui/core/Box";
import BoxTitle from "../components/BoxTitle/BoxTitle";
import QCardCompletedCourses from "../components/QCards/QCardCompletedCourses";
import QCardTrainingHours from "../components/QCards/QCardTrainingHours";
import QCardCertificates from "../components/QCards/QCardCertificates";
import CardRunningCourses from "../components/CardRunningCourses/CardRunningCourses";
import DonutChart from "../components/DonutChart/DonutChart";
import CardRunningActions from "../components/CardRunningActions/CardRunningActions";
import CardNotifications from "../components/CardNotifications/CardNotifications";

import Styles from "./Dashboard.module.css";

const Dashboard = () => {
	return (
		<div className={Styles["dashboard"]} style={{ color: "#ededed" }}>
			<div className={`container ${Styles["container"]}`}>
				<div className={"row"}>
					<div className={"col-xs-12 title"}>
						Formação Profissional
					</div>
				</div>
				<div className={"row"}>
					<div className={"col-xs-6"}>
						<div className={"row"}>
							<div
								className={`col-xs-4 ${Styles["col-padding"]}`}
							>
								<Box
									component="div"
									className={"box-container"}
									sx={{minWidth: "160px"}}
								>
									<QCardCompletedCourses title="Cursos concluidos" />
								</Box>
							</div>
							<div
								className={`col-xs-4 ${Styles["col-padding"]}`}
							>
								<Box
									component="div"
									className={"box-container"}
									sx={{minWidth: "160px"}}
								>
									<QCardTrainingHours title="Horas de Formação" />
								</Box>
							</div>
							<div
								className={`col-xs-4 ${Styles["col-padding"]}`}
							>
								<Box
									component="div"
									className={"box-container"}
									sx={{minWidth: "160px"}}
								>
									<QCardCertificates title="Certificados emitidos" />
								</Box>
							</div>
						</div>
						<div className={"row"}>
							<div
								className={`col-xs-12 ${Styles["col-padding"]}`}
							>
								<Box
									component="div"
									className={"box-container"}
								>
									<BoxTitle title="Cursos a decorrer" />
									<CardRunningCourses />
								</Box>
							</div>
						</div>
						<div className={"row"}>
							<div
								className={`col-xs-12 ${Styles["col-padding"]}`}
							>
								<Box
									component="div"
									className={"box-container"}
								>
									<BoxTitle title="Estado das inscrições" />
									<DonutChart />
								</Box>
							</div>
						</div>
					</div>
					<div className={"col-xs-6"}>
						<div className={"row"}>
							<div
								className={`col-xs-12 ${Styles["col-padding"]}`}
							>
								<Box
									component="div"
									className={"box-container"}
								>
									<BoxTitle title="Módulos a decorrer" />
									<CardRunningActions />
								</Box>
							</div>
						</div>
						<div className={"row"}>
							<div
								className={`col-xs-12 ${Styles["col-padding"]}`}
							>
								<Box
									component="div"
									className={"box-container"}
								>
									<BoxTitle title="Notificações" />
									<CardNotifications />
								</Box>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
